<template>
<v-container>
  <v-layout row>
    <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>
  </v-layout>
  <v-layout row>
    <v-flex>
      <!-- <v-alert :value="error !== ''" color="error">{{error}}</v-alert> -->
      <v-alert :value="info !== ''" color="info">{{info}}</v-alert>
    </v-flex>
  </v-layout>
  <v-layout row>
  <v-flex xs6 offset-xs3>
    <label class="headline">Ange e-postadress att skicka �terst�llningsmail till</label>
    <v-text-field v-model="epost" name="login" label="E-post" type="text" v-on:keyup="checkreturn"></v-text-field>
  </v-flex>
  </v-layout>
  <v-layout row mt-3>
    <v-flex xs2 offset-xs5>
      <v-btn color="secondary" block @click="tillbaka">Tillbaka</v-btn>
    </v-flex>
    <v-flex xs2 ml-1>
      <v-btn color="primary" block @click="sendEmail">Skicka</v-btn>
    </v-flex>
  </v-layout>
</v-container>
</template>

<script>
import {HTTP} from '@/backend/client'

export default {
  data () {
    return {
      loading: false,
      epost: '',
      // error: '',
      info: ''
    }
  },
  methods: {
    checkreturn (e) {
      if (e.keyCode === 13) {
        this.sendEmail()
      }
    },
    sendEmail () {
      // HTTP.post('/token/glomtlosen/', { epost: this.epost }).then(response => {
      HTTP.post('/token/glomtlosen', 'epost=' + this.epost).then(response => {
        this.loading = false
        this.info = 'E-post skickad med inloggningsuppgifter'
      }).catch(e => {
        this.$store.dispatch('appcurrent/showError', e.message)
        // this.error = 'Det gick inte att skicka epost'
      })
    },
    sendEmailSuccessful (req) {
    },
    sendEmailFailed (ex) {
      this.loading = false
    },
    tillbaka () {
      this.$router.go(-1)
    }
  }
}

</script>

<style lang="css" scoped>

</style>



// WEBPACK FOOTER //
// src/components/GlomtLosen.vue